<div class="canvas-toolbar-vertical" (contextmenu)="onContextMenu($event)">
  <button mat-icon-button matTooltip="Toggle sidebar" matTooltipPosition="right" (click)="onToggleSidebar()">
    <mat-icon>menu</mat-icon>
  </button>

  <mat-divider></mat-divider>

  @for (cmd of commands; track cmd.id) {
    @if (cmd.type === 'dialog-invoker') {
      <ddc-command-dialog-invoker [args]="argsFor(cmd)" [command]="cmd" (executed)="onCommandExecuted($event)" />
    } @else {
      <ddc-command-invoker [args]="argsFor(cmd)" [command]="cmd" (executed)="onCommandExecuted($event)" />
    }
  }
</div>

<!-- Toolbar context menu -->
<div
  class="context-menu-trigger"
  [matMenuTriggerFor]="toolbarContextMenu"
  [style.left.px]="contextMenuPosition.x"
  [style.top.px]="contextMenuPosition.y"
></div>
<mat-menu #toolbarContextMenu="matMenu" class="canvas-context-menu">
  @for (cmd of commands; track cmd.id) {
    <button mat-menu-item [disabled]="!cmd.canExecute(argsFor(cmd))" (click)="runCommand(cmd)">
      <mat-icon>{{ cmd.icon }}</mat-icon>
      <span>{{ cmd.label }}</span>
    </button>
  }
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="onToggleSidebar()">
    <mat-icon>view_sidebar</mat-icon>
    <span>Toggle Sidebar</span>
  </button>
</mat-menu>
